export default __webpack_public_path__ + "img/feluy.17a855d3.jpg";